import { ButtonLink } from '@designsforhealth/dfh-react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { css } from 'styled-components'

import { mainMenuInitialTop } from '../../../../lib/header/parallax'
import Link from '../../Link'
import { desktopMenuLinkStyles } from '../styles/desktop-menu'

export const GlobalNav = styled.ul`
  --nav-item-border-width: 4px;
  --nav-item-pad-x: 7px;
  --nav-item-pad-top: 4px;
  --nav-item-pad-bottom: 7px;
  list-style: none;
  padding-left: 0;
  position: absolute;
  top: ${mainMenuInitialTop}px;
  right: 0;
  white-space: nowrap;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: row;
  @media (min-width: 1200px) {
    --nav-item-pad-x: 6px;
    --nav-item-pad-bottom: 8px;
  }
`

const commonNavItemStyles = css`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.1em;
  line-height: 1.5;
  cursor: pointer;
  border-bottom: var(--nav-item-border-width) solid transparent;
  transition:
    color 0.35s,
    border-bottom 0.35s;
  @media (min-width: 1200px) {
    font-size: 13.85px;
  }
`

export const LogoNavItem = styled.li`
  ${commonNavItemStyles};
  padding-right: var(--nav-item-pad-x);
  margin: auto auto 0 0;
  max-height: 43px;
  position: relative;
`

export const DispensaryLogo = styled.img`
  display: block;
  height: 90px;
`

export const DfhLogo = styled.img`
  display: block;
  width: 240px;
  @media (min-width: 1200px) {
    width: 250px;
  }
`

export interface ActivatingNavItemProps {
  $isActive: boolean
}

export const ActivatingNavItem = styled.li<ActivatingNavItemProps>`
  ${commonNavItemStyles};
  margin: auto 3px 0;
  padding: var(--nav-item-pad-top) var(--nav-item-pad-x) var(--nav-item-pad-bottom);
  ${({ $isActive }) =>
    $isActive &&
    css`
      border-bottom-color: #fff;
    `};
`
export const CartActivatingNavItem = styled(ActivatingNavItem)`
  padding: 0;
  margin-bottom: 3px;
  cursor: auto;
`

export const ShopNowNavItem = styled.li`
  ${commonNavItemStyles};
  display: none;
  margin: auto 0 5px 3px;
  padding: var(--nav-item-pad-top) 0 var(--nav-item-pad-bottom) var(--nav-item-pad-x);

  @media (min-width: 1200px) {
    display: block;
  }
`

export const NavItemIcon = styled(FontAwesomeIcon)`
  height: 1em;
`

export const LogoLink = styled(Link)`
  ${desktopMenuLinkStyles};
  position: absolute;
  bottom: 0px;
`

export const SearchLink = styled(ButtonLink)`
  ${desktopMenuLinkStyles};
  font-family: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  color: ${({ theme }) => theme.colors.brand.red};
  display: flex;
  align-items: center;
`

export const CartLink = styled(ButtonLink)`
  ${desktopMenuLinkStyles};
  font-family: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  color: ${({ theme }) => theme.colors.brand.red};
  display: flex;
  align-items: center;
  margin: 0;
  padding: var(--nav-item-pad-top) var(--nav-item-pad-x) calc(var(--nav-item-pad-bottom) + 7.5px);
  cursor: pointer;
`

export const ShopNowButton = styled(Link)`
  display: block;
  background-color: ${({ theme }) => theme.colors.brand.gray};
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool500};
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.grayscale.white};
  text-transform: uppercase;
  padding: 0.4em 1em;
  line-height: 1.5;
  text-decoration: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grayscale.white};
    color: black;
  }
`

export const CartItemCount = styled.span`
  display: inline-block;
  padding-left: 5px;
  width: 2.3em;
  overflow: hidden;
  text-align: left;
`

export const ExtraLargeOnlyText = styled.span`
  display: none;
  @media (min-width: 1200px) {
    display: unset;
    margin-right: 0.5em;
  }
`
